import { Stack, Text } from '@fluentui/react';
import React from 'react';
import { AccessGroups_accessGroups_nodes_accessGroupItems_nodes } from '../__generated__/AccessGroups';
import { useStyles } from './index.styles';

interface AccessGroupItemProps {
  item: AccessGroups_accessGroups_nodes_accessGroupItems_nodes;
}

export const AccessGroupItem: React.FC<AccessGroupItemProps> = ({ item }) => {
  const styles = useStyles();
  const { userGroup } = { ...item };
  const { name } = { ...userGroup };
  return (
    <Stack>
      <Stack verticalAlign="center">
        <Stack verticalAlign="center" className={styles.accessGroup}>
          <Text className={styles.fontColor} variant="medium">
            {name}
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
};
